import React, { useState, useEffect } from 'react';

// Define prop types
interface ToastProps {
  message: string;
  isError?: boolean;
  onClose?: () => void;
  duration?: number;
  show: boolean;  // Add this line back
}

const Toast: React.FC<ToastProps> = ({ 
  message, 
  isError = false, 
  onClose,
  duration = 3000,
  show
}) => {
  const [isVisible, setIsVisible] = useState(show);

  useEffect(() => {
    setIsVisible(show);
  }, [show]);

  useEffect(() => {
    if (isVisible) {
      const timer = setTimeout(() => {
        setIsVisible(false);
        onClose && onClose();
      }, duration);

      return () => clearTimeout(timer);
    }
  }, [isVisible, duration, onClose]);

  if (!isVisible) return null;

  return (
    <div className="fixed top-4 right-4 z-50 min-w-[300px] transform transition-all duration-300 ease-in-out">
      <div className={`
        rounded-3xl p-4 shadow-lg 
        ${isError 
          ? 'bg-red-100 text-red-500 border border-red-500' 
          : 'bg-green-100 text-green-600 border border-green-600'
        }
      `}>
        <div className="flex items-center justify-between">
          <span className="font-medium">{message}</span>
          <button 
            onClick={() => {
              setIsVisible(false);
              onClose && onClose();
            }}
            className="ml-4 text-gray-400 hover:text-gray-600 focus:outline-none"
          >
            <svg className="h-4 w-4" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" viewBox="0 0 24 24" stroke="currentColor">
              <path d="M6 18L18 6M6 6l12 12"></path>
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
};

export default Toast;